module.exports = __webpack_public_path__ + "static/media/avocado_big_mask.1dfdc707.png";